export const onboardingStylesheet = String.raw`
  .onboarding,
  .onboarding-help {
    display: grid;
    gap: var(--herefor-space-4);
    max-inline-size: 42rem;
    margin-block-end: var(--herefor-space-7);
    padding: var(--herefor-space-5);
    background: var(--herefor-color-surface-subtle);
    border: 1px solid var(--herefor-color-border);
    border-radius: var(--herefor-radius-lg);
  }

  .onboarding__eyebrow {
    margin: 0;
    color: var(--herefor-color-accent);
    font-weight: var(--herefor-font-weight-semibold);
  }

  .onboarding__introduction,
  .onboarding__model,
  .onboarding-help > p {
    margin: 0;
    color: var(--herefor-color-text-muted);
  }

  .onboarding__model {
    display: grid;
    gap: var(--herefor-space-2);
    padding-inline-start: var(--herefor-space-5);
  }

  .onboarding__actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--herefor-space-3);
    align-items: center;
  }

  .onboarding__privacy {
    inline-size: fit-content;
  }

  @media (prefers-reduced-motion: reduce) {
    .onboarding,
    .onboarding-help {
      scroll-behavior: auto;
    }
  }
`;
